(function() {
  'use strict';

  var container = document.querySelector('[data-complete-your-kit]');
  if (!container) return;

  var productId = container.getAttribute('data-product-id');
  var limit = container.getAttribute('data-limit') || 5;
  var heading = container.getAttribute('data-heading') || 'Complete Your Kit:';

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  var url = '/recommendations/products.json?product_id=' + productId + '&limit=' + limit + '&intent=complementary';

  fetch(url)
    .then(function(res) { return res.json(); })
    .then(function(data) {
      var products = data.products;
      if (!products || !products.length) {
        return;
      }

      var html = '<h3 class="complete-your-kit__heading">' + heading + '</h3>';
      html += '<div class="complete-your-kit__list">';

      var visibleCount = 3;

      products.forEach(function(product, index) {
        var variant = product.variants[0];
        var priceHtml = '';

        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceHtml = '<span class="complete-your-kit__price--sale money">' + formatMoney(variant.price) + '</span>';
          priceHtml += ' <span class="complete-your-kit__price-compare money">' + formatMoney(variant.compare_at_price) + '</span>';
        } else {
          priceHtml = '<span class="money">' + formatMoney(variant.price) + '</span>';
        }

        var imgSrc = product.featured_image ? product.featured_image + '&width=120' : '';
        if (imgSrc && imgSrc.indexOf('?') === -1) {
          imgSrc = product.featured_image + '?width=120';
        }
        var imgHtml = imgSrc ? '<img src="' + imgSrc + '" alt="' + product.title.replace(/"/g, '&quot;') + '" loading="lazy">' : '';

        var productUrl = product.url || ('/products/' + product.handle);
        var hiddenClass = index >= visibleCount ? ' complete-your-kit__item--hidden' : '';

        html += '<div class="complete-your-kit__item' + hiddenClass + '" data-complementary-item>';
        html += '<input type="checkbox" class="complete-your-kit__checkbox" data-complementary-checkbox data-variant-id="' + variant.id + '"' + (variant.available ? '' : ' disabled') + ' aria-label="' + product.title.replace(/"/g, '&quot;') + '">';
        html += '<div class="complete-your-kit__details">';
        html += '<p class="complete-your-kit__title"><a href="' + productUrl + '">' + product.title + '</a></p>';
        html += '<p class="complete-your-kit__price">' + priceHtml + '</p>';
        html += '</div>';
        html += '<div class="complete-your-kit__image"><a href="' + productUrl + '">' + imgHtml + '</a></div>';
        html += '</div>';
      });

      html += '</div>';

      if (products.length > visibleCount) {
        html += '<button type="button" class="complete-your-kit__show-more" data-show-more>Show More (' + (products.length - visibleCount) + ')</button>';
      }

      container.innerHTML = html;

      var showMoreBtn = container.querySelector('[data-show-more]');
      if (showMoreBtn) {
        showMoreBtn.addEventListener('click', function() {
          var hiddenItems = container.querySelectorAll('.complete-your-kit__item--hidden');
          hiddenItems.forEach(function(item) {
            item.classList.remove('complete-your-kit__item--hidden');
          });
          showMoreBtn.remove();
        });
      }
    })
    .catch(function(err) {
      console.error('Complete Your Kit: Failed to load recommendations', err);
    });

  // Bundle checked items with main ATC
  document.addEventListener('addToCartFlyout:complete', function(event) {
    if (!event.detail || !event.detail.success) return;

    var checkboxes = document.querySelectorAll('[data-complementary-checkbox]:checked');
    if (!checkboxes.length) return;

    var items = [];
    checkboxes.forEach(function(checkbox) {
      var variantId = checkbox.getAttribute('data-variant-id');
      if (variantId) {
        items.push({ id: parseInt(variantId, 10), quantity: 1, properties: { '_added_via': 'complete-your-kit-product' } });
      }
    });

    if (!items.length) return;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function(response) {
      if (!response.ok) throw new Error('Failed to add complementary products');
      return response.json();
    })
    .then(function() {
      return fetch('/cart.js').then(function(r) { return r.json(); });
    })
    .then(function(cart) {
      window.dispatchEvent(new CustomEvent('cartcount:update', {
        detail: { item_count: cart.item_count }
      }));
    })
    .catch(function(error) {
      console.error('Complete Your Kit:', error);
    });
  });
})();
